// Carries the shared navigation control's measured width across a locale-route
// change so the next render can animate from the old language to the new one.
export const LOCALE_NAV_WIDTH_KEY = "otekse-locale-nav-width";
